import React, { useEffect } from 'react';
import { Image, ScrollView, View } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import Colors from '../../constants/Colorsv2';
import { useDispatch, useSelector } from 'react-redux';
import { V1_SHOW_AUTHENTICATE, V1_SHOW_PROFILE } from '../../store/actionsv1/types';
import { TouchableOpacity, Text } from '../../globalComponents/NativeOverrides';
import { player_getHelpPromptById } from '../../store/actionsv1/player';
import { BEEventApi, Components, LinearGradient } from 'be-components';
import { auth_logout } from '../../store/actionsv1/auth';
import { Helmet } from 'react-helmet-async';

const AuthenticateScreen = ({ navigation, appSize }:any) => {
    const dispatch = useDispatch();
    const insets = useSafeAreaInsets();
    const app_size = useSelector((state:any) => state.util.app_size, (left, right) => left == right);
    const is_authenticated = useSelector((state:any) => state.auth.isAuthenticated, (left, right) => left == right)
    const vieweing_referral = useSelector((state:any) => state.player.viewing_player_referral, (left, right) => left == right);

    const getStarted = () => {
        dispatch({ type:V1_SHOW_AUTHENTICATE, show_authenticate: { visible: true, hide_close:false, nav_out:true } })
    }

    useEffect(() => {
        if(!vieweing_referral || is_authenticated){ return }
        getStarted()
    },[vieweing_referral])

    return (
        <View style={{ flex:1, backgroundColor:Colors.brand.midnight, paddingTop:insets.top }}>
            <Helmet>
                <title>BettorEdge - Social Betting Marketplace</title>
                <meta property='og:description' content='Sign Up now and bet against other users and not the house on your favorite sporting events' />
                <meta name='og:image' content={'https://res.cloudinary.com/hoabts6mc/image/upload/v1692636739/2x1_be_logo_nniluh.webp'} />
            </Helmet> 
                <View style={{ position:'absolute', top:0, bottom:0, left:0, right:0, backgroundColor:Colors.shades.black_faded }}>
                    <Image
                        source={require('../../assets/images/social_sports.webp')}
                        style={{ height:app_size.height, width:app_size.width, opacity: 0.5 }}
                        resizeMode='cover'
                    />
                </View>
                <Image
                    source={require('../../assets/images/be_lightning.webp')} 
                    style={{ width:app_size.width, height:app_size.width*0.2 }}
                    resizeMode='cover'/>
                <View style={{justifyContent:'center', alignItems:'center', padding:30, marginTop:0}}>
                    <Image source={require('../../assets/images/be_descriptor.webp')} style={{ width:220, height:52 }} resizeMode='contain' />
                </View>
                <View style={{ flex:1, marginTop:20 }} nativeID='button_options'>
                <LinearGradient 
                    colors={[Colors.shades.white, Colors.shades.shade100]}
                    style={{ minHeight:400, minWidth:300, padding:20, borderRadius:8, alignSelf:'center' }}
                    >
                    <View style={{ marginBottom:30, justifyContent:'center', alignItems:'center' }}>
                        <Components.Icons.BettorEdgeIcon
                            size={32}
                            color={Colors.brand.midnight}
                        />
                    </View>
                    <View style={{ flex:1, justifyContent:'center', alignItems:'center' }}>
                        {is_authenticated ?
                        <Components.Button
                            title='LOGOUT'
                            style={{ width:200 }}
                            padding={15}
                            backgroundColor={Colors.utility.error}
                            borderWidth={1}
                            borderColor={Colors.utility.error}
                            title_color={Colors.shades.white}
                            onPress={() => dispatch(auth_logout())}
                        />
                        :
                        <Components.Button
                            title='SIGN UP / LOGIN'
                            style={{ width:200 }}
                            padding={15}
                            backgroundColor={Colors.utility.success}
                            borderWidth={1}
                            borderColor={Colors.utility.success}
                            title_color={Colors.shades.white}
                            onPress={() => getStarted()}
                        />
                        }
                        <Components.Button
                            title='WHAT IS BETTOREDGE?'
                            style={{ marginTop:20, width:200 }}
                            padding={15}
                            backgroundColor={Colors.shades.white}
                            borderWidth={1}
                            borderColor={Colors.brand.midnight}
                            title_color={Colors.brand.midnight}
                            onPress={() => {
                                dispatch(player_getHelpPromptById('t2_welcome_1'))
                            }}
                        />
                        <Components.Button
                            title='EXPLORE BETTOREDGE'
                            style={{ marginTop:20, width:200 }}
                            padding={15}
                            backgroundColor={Colors.utility.success}
                            borderWidth={1}
                            borderColor={Colors.utility.success}
                            title_color={Colors.shades.white}
                            onPress={() => navigation.navigate('Auth', { screen:'EventStack' })}
                        />
                        {is_authenticated ?
                        <Components.Button
                            title='CHECKOUT PREMIUM'
                            style={{ marginTop:20, width:200 }}
                            padding={15}
                            backgroundColor={Colors.incentive.gold}
                            title_color={Colors.shades.white}
                            onPress={() => navigation.push('Premium')}
                        />
                        :<></>}
                        <View style={{ marginTop:30 }}>
                            <Image
                                source={require('../../assets/images/sbc_rising_start.webp')}
                                style={{ width:150, height: 59 }}
                                resizeMode='contain'
                            />
                        </View>
                    </View>
                    
                    </LinearGradient>
                    
                </View>
        </View>
    )
}

export default AuthenticateScreen